import { render } from "./EditShowModal.vue?vue&type=template&id=e4fb6f88"
import script from "./EditShowModal.vue?vue&type=script&lang=ts"
export * from "./EditShowModal.vue?vue&type=script&lang=ts"
script.render = render

export default script